module.exports = __webpack_public_path__ + "img/check-icon.4feee798.png";